<template>
    <div>
        <breadcrumbs
            :title="'Suorganizatori'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Suorganizator: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <suorganizator-forma
                    :disabled="false"
                    :id="id"
                    :modal="false"
                    :action="'edit'"
                    @returnData="setData"
                ></suorganizator-forma>
            </div>
        </div>
    </div>
</template>

<script>
import SuorganizatorForma from "./SuorganizatorForma";
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
export default {
    name: "SuorganizatorEdit",
    components: {
        Breadcrumbs,
        SuorganizatorForma
    },
    data(){
        return {
            id: this.$route.params.suorganizator_id,
            breadcrumbs: [],
            naziv: ''
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/postavke/suorganizatori',
                    name: 'Suorganizatori'
                },
                {
                    path: '/postavke/suorganizatori/' + this.id,
                    name: 'Suorganizator: ' + this.naziv
                },
                {
                    path: '/postavke/suorganizatori/' + this.id + '/edit',
                    name: 'Uredi suorganizatora: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.naziv || ''
            this.setBreadcrumbs()
        }
    }
};
</script>

<style scoped>

</style>
